import "../services.css"
import "../servicescovers.css"

import { useState, useRef, useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';
import R from "../../../assets/Images/Quote/Hero-Section.jpg"

import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"
import QuotationComponent from "../../../assets/components/06_quotation_component/quotation_component"
import test from "../../../assets/Images/Elements/M-Orange.svg"

export default function PerformanceReporting() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 8;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <HelmetProvider>
                <title>Data-Driven Analytics & Reporting Services for Brands in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai providing analytics & performance reporting, social media marketing in Mumbai, Instagram marketing agency services, and insights for business growth." />
                <link rel="canonical" href="https://adstrate.in/services/analytics-and-performance-reporting" />
            </HelmetProvider>
            <Header />
            <div className="ServicesDetails-HeroSection ServicesDetails-HeroSection-Website">
                <div className="ServicesDetails-HeroSection-Glass">
                    <h1>Analytics & Performance Reporting</h1>
                    <p>Adstrate, a trusted digital marketing agency in Mumbai, delivers detailed analytics and performance reporting to help brands measure results, optimize campaigns, and achieve marketing goals.</p>
                    <a href="/quotation">
                        <p className="LinkLabel">Get Quote</p>
                        <img src={Arrow}/>
                    </a>
                </div>
            </div>
            <div className="ServicesPages-Services-Main">
                <div className="ServicesPages-Services-Info">
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Discovery & KPI Definition</h2>
                            <p>
                                Understand business objectives, key performance indicators, and target outcomes.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Analytics Setup</h2>
                            <p>
                                Configure tracking on websites, ad accounts, and social media platforms.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Data Monitoring</h2>
                            <p>
                                Continuously monitor performance metrics for campaigns, website traffic, and engagement.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Report Compilation</h2>
                            <p>
                                Generate clear, concise reports highlighting insights and optimization opportunities.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Insight Sessions</h2>
                            <p>
                                Review results, identify gaps, and recommend improvements based on data.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Optimization Recommendations</h2>
                            <p>
                                Provide actionable strategies to improve campaign and channel performance.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Offboarding & Handover</h2>
                            <p>
                               Deliver final reports, grant data access, and outline recommendations for future campaigns.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 8 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Strategic Guidance</h2>
                            <p>
                                Support informed decision-making to drive long-term growth and ROI.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ServicesPages-Services-Selector" ref={selectorRef}>
                    <div className="ServicesPages-Services-Selector-Selection">
                        {[
                        "Discovery & KPI Definition",
                        "Analytics Setup",
                        "Data Monitoring",
                        "Report Compilation",
                        "Insight Sessions",
                        "Optimization Recommendations",
                        "Offboarding & Handover",
                        "Strategic Guidance",

                        ].map((text, index) => (
                        <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "ServicesPages-Services-Selector-Card Home-active MicroLinksText" : "ServicesPages-Services-Selector-Card"}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            <div className="ServicesPages-Services-Selector-selection"></div>
                            <div className="ServicesPages-Services-Selector-hover"></div>
                            <p>{text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
            <QuotationComponent />
            <Footer />
        </div>
    );
}